import { createFileRoute, Link } from "@tanstack/react-router";
import headImg from "@/assets/public/story-founders.jpg";
import fuelLogo from "@/assets/public/fuel-louisiana-logo.jpg.asset.json";
import { PageHead, Shell } from "@/components/public/site";

export const Route = createFileRoute("/partners/")({
  head: () => ({
    meta: [
      { title: "Ecosystem Partners — Maven Scouts" },
      { name: "description", content: "The government, industry, academic, and investment partners that power the Maven Scouts dual-use ecosystem." },
      { property: "og:title", content: "Ecosystem Partners — Maven Scouts" },
      { property: "og:description", content: "Join the Maven Scouts dual-use ecosystem." },
    ],
  }),
  component: Page,
});

const groups = [
  { code: "ECO-01", title: "Government & Defense", body: "Program offices, labs, and operational units who define requirements and transition capability to the field." },
  { code: "ECO-02", title: "Industry & Primes", body: "Established integrators and manufacturers who scale proven prototypes into production." },
  { code: "ECO-03", title: "Startups & Innovators", body: "Emerging dual-use companies bringing breakthrough technology into defense and commercial markets." },
  { code: "ECO-04", title: "Academia & Research", body: "Universities and research centers advancing the science behind next-generation systems." },
  { code: "ECO-05", title: "Capital & Investors", body: "Investors backing mission-driven technology with the patience to see it through transition." },
  { code: "ECO-06", title: "Test & Evaluation", body: "Ranges and facilities that validate performance in realistic operational environments." },
];

function Page() {
  return (
    <Shell>
      <PageHead image={headImg} alt="Founders presenting to investors and partners" code="Ecosystem Partners" title="Stronger together" sub="A network connecting government, industry, research, and capital to move dual-use technology from concept to deployment." />
      <div className="mx-auto max-w-7xl px-6 py-20">
        <div className="grid gap-px bg-border md:grid-cols-3">
          {groups.map((g) => (
            <div key={g.code} className="bg-background p-8">
              <p className="font-mono text-xs text-highlight">{g.code}</p>
              <h2 className="mt-4 font-display text-2xl uppercase">{g.title}</h2>
              <p className="mt-4 text-sm text-muted-foreground">{g.body}</p>
            </div>
          ))}
        </div>
        <section className="mt-16">
          <p className="font-mono text-xs uppercase tracking-widest text-highlight">Featured Partners</p>
          <a href="https://fuelouisiana.org/" target="_blank" rel="noopener noreferrer" aria-label="Visit FUEL Louisiana" className="group mt-6 grid items-center gap-8 border border-border bg-background p-8 transition-colors hover:border-primary hover:bg-muted md:grid-cols-[280px_1fr]">
            <img src={fuelLogo.url} alt="FUEL Louisiana — NSF Engine logo" className="h-28 w-full object-contain" loading="lazy" />
            <div>
              <h2 className="font-display text-2xl uppercase">FUEL Louisiana</h2>
              <p className="mt-3 text-sm text-muted-foreground">FUEL (Future Use of Energy in Louisiana) leads the NSF FUEL Engine — connecting universities, colleges, state agencies, entrepreneurs, industry, and investors to make Louisiana a global leader in energy innovation through research, technology commercialization, and workforce development.</p>
              <span className="mt-5 inline-block font-mono text-xs uppercase tracking-widest text-primary group-hover:underline">Visit fuelouisiana.org →</span>
            </div>
          </a>
        </section>
        <div className="mt-16 border border-border bg-card p-10 text-center">
          <h2 className="font-display text-4xl uppercase">Join the ecosystem</h2>
          <Link to="/intake" className="mt-8 inline-block bg-primary px-8 py-4 font-mono text-xs uppercase tracking-widest text-primary-foreground hover:bg-secondary">Accelerate Now</Link>
        </div>
      </div>
    </Shell>
  );
}
